<template>
  <div>
    <el-popconfirm :title="title" @confirm="confirm">
      <el-button
        slot="reference"
        :type="type"
      >
        <slot />
      </el-button>
    </el-popconfirm>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary'
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>
